import CustomerWorkOrderList from "../../views/CustomerWorkOrderList";

const CustomerWorkOrderPage = () => {
  return <CustomerWorkOrderList />;
};

export default CustomerWorkOrderPage;
